export const ACTIVE_CAMPAIGN_ID = 'base_campaign'
